import './styles.css';

import React, { Component } from 'react';
import Content from "../../content/Content";
import HeaderText from "../HeaderText/HeaderText";
import InputField from "../InputField/InputField";
import Gutter from "../Gutter/Gutter";
import {xhrSaveUserInfo} from "./Services/Services";
import Constants from "../../constants/Constants";


class GetInTouch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            message: "",
            showMessage: false,
            validationMessage: ""
        };

        this.formValidation = [];

        this.formControls ={
            NAME: 0,
            EMAIL: 1,
            MESSAGE: 2
        };

    };

    componentWillMount() {

        this.formValidation[this.formControls.NAME] = false;
        this.formValidation[this.formControls.EMAIL] = false;
        this.formValidation[this.formControls.MESSAGE] = false;

    }

    getFormData = () => {

        const { name, email, message} = this.state;

        let formData = new FormData();
        formData.append("name", name);
        formData.append("email", email);
        formData.append("description", message);
        return formData;

    };

    validateData = () => {
        if(!this.formValidation[this.formControls.NAME] && !this.formValidation[this.formControls.EMAIL] && !this.formValidation[this.formControls.MESSAGE]) {
            this.setState({
                showMessage: true,
                validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.ENTER_FULL_NAME_EMAIL_ID_AND_MESSAGE
            });
        }
        else if(!this.formValidation[this.formControls.NAME] && !this.formValidation[this.formControls.EMAIL] && this.formValidation[this.formControls.MESSAGE]) {
            this.setState({
                showMessage: true,
                validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.ENTER_FULL_NAME_AND_EMAIL_ID
            });
        }
        else if(!this.formValidation[this.formControls.NAME] && this.formValidation[this.formControls.EMAIL] && !this.formValidation[this.formControls.MESSAGE]) {
            this.setState({
                showMessage: true,
                validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.ENTER_FULL_NAME_AND_MESSAGE
            });
        }
        else if(this.formValidation[this.formControls.NAME] && !this.formValidation[this.formControls.EMAIL] && !this.formValidation[this.formControls.MESSAGE]) {
            this.setState({
                showMessage: true,
                validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.ENTER_EMAIL_ID_AND_MESSAGE
            });
        }
        else if(!this.formValidation[this.formControls.NAME] && this.formValidation[this.formControls.EMAIL] && this.formValidation[this.formControls.MESSAGE]) {
            this.setState({
                showMessage: true,
                validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.ENTER_FULL_NAME
            });
        }
        else if(this.formValidation[this.formControls.NAME] && !this.formValidation[this.formControls.EMAIL] && this.formValidation[this.formControls.MESSAGE]) {
            this.setState({
                showMessage: true,
                validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.ENTER_EMAIL_ID
            });
        }
        else if(this.formValidation[this.formControls.NAME] && this.formValidation[this.formControls.EMAIL] && !this.formValidation[this.formControls.MESSAGE]) {
            this.setState({
                showMessage: true,
                validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.ENTER_MESSAGE
            });
        }

    };

    saveUserInfo = () => {
        xhrSaveUserInfo(this.getFormData(), this.saveUserInfoSuccess, this.saveUserInfoFailure)
    };

    saveUserInfoSuccess = () => {

        this.setState({
            showMessage: true
        });

    };

    saveUserInfoFailure = () => {
        this.setState({
            showMessage: true,
            validationMessage: Content.GET_IN_TOUCH.VALIDATION_MESSAGE.SOMETHING_WENT_WRONG
        });
    };

    onChangeName = (name) => {

        this.setState({
            name
        });

        if(name) {
            this.formValidation[this.formControls.NAME] = true;
        }
        else {
            this.formValidation[this.formControls.NAME] = false;
        }

    };

    onChangeEmail = (email) => {

        this.setState({
            email
        });

        this.formValidation[this.formControls.EMAIL] = Constants.REGEX.EMAIL.test(email);

    };

    onChangeMessage = (message) => {

        this.setState({
            message
        });

        if(message) {
            this.formValidation[this.formControls.MESSAGE] = true;
        }
        else {
            this.formValidation[this.formControls.MESSAGE] = false;
        }

    };

    onClickSubmit = () => {
        if(this.validateData()) {
            this.saveUserInfo();
        }

    };

    render() {

        const {
            name,
            email,
            message,
            showMessage,
            validationMessage
        } = this.state;

        return (
            <div className="get-in-touch">

                <div
                    id="get-in-touch"
                    style={{
                    position: 'absolute',
                    top: '-60px'
                }}
                ></div>

                <Gutter height={40}/>

                <HeaderText
                    headerText = {Content.GET_IN_TOUCH.GET_IN_TOUCH}
                    customStyleHeaderText = {{
                        padding: '0',
                        font: 'normal 36px/40px GillSans Regular',
                        margin: '0 0 20px 0'
                    }}
                />

                <HeaderText
                    headerText = {Content.GET_IN_TOUCH.GET_IN_TOUCH_CONTENT_1}
                    customStyleHeaderText = {{
                        padding: '0',
                        font: 'normal 16px/1.6em GillSans Regular',
                        margin: '40px 0 0 0'
                    }}
                />

                {/*<HeaderText*/}
                    {/*headerText = {Content.GET_IN_TOUCH.GET_IN_TOUCH_CONTENT_2}*/}
                    {/*customStyleHeaderText = {{*/}
                        {/*padding: '0',*/}
                        {/*font: 'normal 16px/1.6em GillSans Regular'*/}
                    {/*}}*/}
                {/*/>*/}
                <div className="support-mail">
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                    <a href="mailto:support@talentxo.com" target="_top">hire@talentxo.com</a>
                </div>

                <Gutter height={40}/>

                <div className="git-input">
                    <InputField
                        type = {"text"}
                        placeholder = {Content.GET_IN_TOUCH.PLACEHOLDER.FULL_NAME}
                        value = {name}
                        onChange = {this.onChangeName}
                    />

                    <Gutter height={17}/>

                    <InputField
                        type = {"text"}
                        placeholder = {Content.GET_IN_TOUCH.PLACEHOLDER.EMAIL_ID}
                        value = {email}
                        onChange = {this.onChangeEmail}
                    />

                    <Gutter height={17}/>

                    <InputField
                        type = {"textarea"}
                        placeholder = {Content.GET_IN_TOUCH.PLACEHOLDER.MESSAGE}
                        value = {message}
                        onChange = {this.onChangeMessage}
                    />

                    <Gutter height={17}/>

                    <div className="git-btn">
                        <button onClick={this.onClickSubmit}>SUBMIT</button>
                    </div>

                </div>

                {
                    showMessage ?
                        <div className="validation-message">{validationMessage}</div>
                        :
                        null
                }

                <Gutter height={40}/>




            </div>
        )

    }

}

export default GetInTouch;



// WEBPACK FOOTER //
// ./src/components/GetInTouch/GetInTouch.js